import { useEffect } from 'react';

import { initTheme, ThemeName } from '@xemplo/root-style';

// Global CSS foundation for the CSS-Modules migration: design-token variables
// and the typography ramp (the classes components pull in via
// `composes ... from global`). Imported once here so every app gets them.
import '@xemplo/root-style/root.css';
import '@xemplo/root-style/variables.css';
import '@xemplo/root-style/typography.css';

/**
 * Resolve + apply the theme (stored choice, else OS preference) by stamping
 * data-theme on <html>. See @xemplo/root-style. NOTE: to fully avoid a
 * light→dark flash once dark mode ships, this should move to a pre-render
 * step (main.tsx / inline head script) — acceptable as an effect for now.
 */
export function useRootStyle(theme?: ThemeName) {
  useEffect(() => {
    initTheme(theme);
  }, [theme]);
}
